import * as React from "react";
import { IAction } from "epics/base-epic";
import { Dispatch, connect } from "react-redux";
import Chip from "@material-ui/core/Chip";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { IStore } from "reducers";
import { DEFAULT_MASTER_VIEW_NAME, DEFAULT_VIEW_NAME, setViewToDefault } from "actions/collections";
import { withRouter } from "react-router";
import { CollectionSavedViewRollupSeparator } from "./product-collection-views/product-collection-grid-view/tool-panels/data-view-panel";
import { DATATEST } from "constants/integration";

interface IStateProps {
    currentViewName: string;
    gridApi: any;
}

interface IDispatchProps {
    onSetViewToDefault: (collectionId: string) => IAction<any>;
}

interface IOwnProps {
    collectionId: string;
    onClearViewParams: () => void;
    className?: string;
    isRollupMode: boolean;
}

type IProps = IOwnProps & IDispatchProps & IStateProps & { router: any };

const CurrentSavedViewChipFunction = ({
    collectionId,
    currentViewName,
    gridApi,
    onSetViewToDefault,
    onClearViewParams,
    router,
    className,
    isRollupMode,
}: IProps) => {
    const handleDelete = React.useCallback(() => {
        onSetViewToDefault(collectionId);
        onClearViewParams();
        router.push({ pathname: router.location.pathname, query: { ...router.location.query, viewId: undefined } });
    }, [onSetViewToDefault, collectionId, router, onClearViewParams]);

    const openViewToolPanel = React.useCallback(() => {
        gridApi.openToolPanel("views");
    }, [gridApi]);
    let chipLabel = currentViewName;
    if (isRollupMode && currentViewName === DEFAULT_MASTER_VIEW_NAME) {
        return null;
    }

    if (!isRollupMode && [DEFAULT_VIEW_NAME, DEFAULT_MASTER_VIEW_NAME].includes(currentViewName)) {
        return null;
    }

    if (isRollupMode) {
        const currentViewId = router.location.query.viewId.split(CollectionSavedViewRollupSeparator)[0];
        chipLabel = currentViewId ? currentViewName.split(currentViewId)[0] : currentViewName;
    }

    return (
        <Chip
            data-test={DATATEST.ASSORTMENTS.SAVED_VIEW_CHIP}
            className={className}
            icon={<VisibilityIcon />}
            label={chipLabel}
            clickable={true}
            onClick={openViewToolPanel}
            onDelete={handleDelete}
            classes={{
                label: "chipLabel",
            }}
            style={{
                maxWidth: "180px",
            }}
        />
    );
};

const mapStateToProps = (state: IStore, _ownProps: IOwnProps): IStateProps => {
    const {
        collectionItemDisplayPreference: { currentViewName },
        collection: { gridApi },
    } = state;
    return {
        currentViewName,
        gridApi,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IAction<any>>, _ownProps: IOwnProps): IDispatchProps => {
    return {
        onSetViewToDefault: (collectionId: string) => dispatch(setViewToDefault(collectionId)),
    };
};

const CurrentSavedViewChip = withRouter(
    connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(CurrentSavedViewChipFunction)
);

// separate export statement so function name shows up in React DevTools
export { CurrentSavedViewChip };
